import {
  Article,
  ArticleFooter,
  ArticleImage,
  ArticleTitle,
} from "@babackapp/customer-ui/components/article";
import { Badge } from "@babackapp/customer-ui/components/badge";
import { useLocalizeLineItem } from "@babackapp/return-widget-components/hooks/use-localize-line-item";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@babackapp/customer-ui/components/tooltip";
import type { OrderLineItem } from "@babackapp/return-widget-components/types";
import { InfoIcon } from "lucide-react";
import { LineItemSubtitle } from "./line-item-subtitle";
import { useNonReturnableLabel } from "./use-non-returnable-label";

type Props = {
  lineItem: OrderLineItem;
  currency?: string;
  isConnectedUser?: boolean;
  connectedUserTooltip?: string;
};

export function NonReturnableRow({
  lineItem,
  currency = "EUR",
  isConnectedUser = false,
  connectedUserTooltip,
}: Props) {
  const getLabel = useNonReturnableLabel();
  const localize = useLocalizeLineItem();
  const displayed = localize(lineItem);

  return (
    <Article className="opacity-50 cursor-not-allowed select-none">
      <ArticleImage
        src={lineItem.image}
        layoutId={`img-${lineItem.line_item_id}`}
      />
      <ArticleTitle>{displayed.title}</ArticleTitle>
      <LineItemSubtitle lineItem={displayed} currency={currency} />
      {isConnectedUser && lineItem.sku && (
        <ArticleFooter className="flex items-center gap-1.5">
          <span>{lineItem.sku}</span>
          <Tooltip>
            <TooltipTrigger asChild>
              <InfoIcon className="size-3.5 cursor-help" />
            </TooltipTrigger>
            <TooltipContent>{connectedUserTooltip}</TooltipContent>
          </Tooltip>
        </ArticleFooter>
      )}
      <Badge variant="secondary">{getLabel(lineItem)}</Badge>
    </Article>
  );
}
